export const de = {
  upload: "Hochladen",
  cancel: "Stornieren",
  close: "Schließen",
  uploading: "Hochladen ...",
  uploaded: "Hochgeladen",
  fetching: "Bild abrufen von $1$ ...",
  poweredBy: "Ermöglicht durch $1$",
  needHelp: "Benötigen Sie Hilfe?",
  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },
  errors: {
    response_not_ok: "Beim Abrufen dieser Datei ist ein Fehler aufgetreten",
    unable_to_search: "Bei der Suche ist ein Fehler aufgetreten",
    invalid_service_url: "Dies ist keine $1$ -URL",
    invalid_url: "Diese URL ist ungültig",
    upload_aborted: "Dein Upload wurde abgebrochen",
    upload_error: "Beim Hochladen dieser Datei ist ein Fehler aufgetreten",
    file_type_not_allowed: "Dieser Dateityp wird nicht unterstützt",
    file_too_large: "Die Datei muss kleiner als $1$ sein",
  },
  help: {
    loading: "Ladehilfe...",
    close: "Hilfe schließen",
  },
  services: {
    default: {
      heading: "Wählen Sie ein Bild aus",
    },
    local: {
      title: "Wählen Sie eine Datei",
      button: "Wählen Sie eine Datei aus",
      or: "von",
      drop: "Ziehen Sie eine Datei hierher, um sie hochzuladen",
    },
    camera: {
      title: "Kamera",
      button: "Webcam Foto",
      switch: "Kamera wechseln",
      waiting: "Warten auf Kameraerlaubnis ...",
      unableToRead:
        "Wir können das Video nicht von Ihrer Kamera lesen. Dies kann daran liegen, dass Sie nicht die erforderliche Berechtigung erteilt haben oder dass Ihr Gerät den Kamerazugriff nicht unterstützt.",
    },
    microlink: {
      button: "Import von $1$",
      label: "$1$ $2$ URL",
      placeholder: "Geben Sie eine URL von 1 bis 2 US-Dollar ein",
      type: "Post",
    },
    url: {
      title: "Direkte URL",
      label: "Bild-URL",
      placeholder: "Geben Sie eine Bild-URL ein",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "ein foto",
    },
    ninegag: {
      title: "9GAG",
      type: "ein foto",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Twitter",
      type: "Foto-Tweet",
    },
    pinterest: {
      title: "Pinterest",
      type: "Stift",
    },
    flipboard: {
      title: "Flipboard",
      type: "artikel",
    },
    fotki: {
      title: "Fotos",
      type: "ein foto",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "Wir lieben es",
    },
    screenshot: {
      title: "Bildschirmfoto",
      button: "Screenshot machen",
      label: "URL der Webseite",
      placeholder: "Geben Sie eine URL ein",
      loading: "Machen Sie einen Screenshot ...",
    },
    search: {
      button: "Suchen Sie nach $1$",
      label: "Suchen Sie nach einem Bild",
      placeholder: "Suche nach etwas",
      imagesPoweredBy: "Bilder möglich gemacht von $1$",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Aufspritzen",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },
  effects: {
    preview: {
      title: "Beispiel",
    },
    filters: {
      title: "Filter",
    },
    crop: {
      title: "Zuschneiden",
      aspectRatios: {
        free: "Frei",
        square: "voll",
      },
    },
    rotate: {
      title: "Wende dich",
    },
    flip: {
      title: "Dreh dich um",
      buttons: {
        horizontal: "Horizontal",
        vertical: "Vertikal",
      },
    },
    sharpen: {
      title: "Schärfen",
    },
    blur: {
      title: "Unschärfe",
    },
    brightness: {
      title: "Helligkeit",
    },
    contrast: {
      title: "Kontrast",
    },
    grayscale: {
      title: "Graustufen",
    },
    "hue-rotate": {
      title: "Farbton drehen",
    },
    invert: {
      title: "Umdrehen",
    },
    saturate: {
      title: "Sättigen",
    },
    sepia: {
      title: "Sepia",
    },
  },
};
